// extracted by mini-css-extract-plugin
export default {"appearTransition":"100ms","wrapperClass":"lGlXTBKSQFEZfcipqfXb"};